"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var Toast = exports["default"] = /*#__PURE__*/function () {
  function Toast(board) {
    (0, _classCallCheck2["default"])(this, Toast);
    // 애니메이션 Debounce 처리
    (0, _defineProperty2["default"])(this, "removeToast", _.debounce(function (toast) {
      toast.$toast.removeClass('fadeToast');
    }, 3000));
    if (Toast.instance) {
      return Toast.instance;
    }
    this.board = board;
    this.$boardView = $(board.view);
    this.generateView();
    Toast.instance = this;
  }
  return (0, _createClass2["default"])(Toast, [{
    key: "generateView",
    value: function generateView() {
      var template = "\n            <div class=\"entryMobileToast hideToast\">\n                <div class=\"content\"/>\n            </div>\n        ";
      this.$view = $('<div class="entryMobileToastWrapper">').append(template);
      this.$toast = this.$view.find('.entryMobileToast');
      this.$content = this.$view.find('.content');
      if (!this.$boardView.has(this.$view).length) {
        this.$boardView.append(this.$view);
      }
    }
  }, {
    key: "show",
    value: function show(message) {
      this.$content.text(message);
      this.$toast.removeClass('fadeToast');
      $(this.$toast).width();
      this.$toast.addClass('fadeToast');
      this.removeToast(this);
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.removeToast.cancel();
      delete this.$boardView;
      delete this.board;
      delete this.$view;
      delete this.$toast;
      delete this.$content;
      delete Toast.instance;
    }
  }]);
}();
(0, _defineProperty2["default"])(Toast, "instance", void 0);